<template>
  <div class="box">
    <div class="loading-spinner-outer" v-if="saving">
      <div class="loading-spinner-inner">
        <div class="loading-spinner"></div>
        <div class="loading-spinner-content">
          Saving, please wait
        </div>
      </div>
    </div>
    <div class="loading-spinner-outer" v-if="deleting">
      <div class="loading-spinner-inner">
        <div class="loading-spinner"></div>
        <div class="loading-spinner-content">
          Deleting, please wait
        </div>
      </div>
    </div>
    <div class="box-content">
      <table class="table _lined">
        <thead>
        <tr>
          <th>
            Faq Type
          </th>
          <th>
            Category Name
          </th>
          <th style="width: 100px;" class="align-center">
            Sort Order
          </th>
          <th></th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-if="new_category">
          <td>
            <select v-model="new_category.faq_type_id" class="form-control">
              <option disabled :value="null">Select FAQ Type</option>
              <option v-for="faq_type in faq_types" :value="faq_type.id"> {{ faq_type.label }}</option>
            </select>
          </td>
          <td>
            <input type="text" v-model="new_category.label" class="form-control" placeholder="New Category Name">
          </td>
          <td>
          </td>
          <td style="width: 30px;">
          </td>
          <td @click="createCategory()" style="width: 30px;" class="cursor-pointer">
            <i class="fal fa-save"></i>
          </td>
        </tr>
        <tr v-for="category in categories" v-if="editing.id !== category.id">
          <td>
            <input type="text" v-model="category.faq_type.label" class="form-control _stealth" readonly>
          </td>
          <td>
            <input type="text" v-model="category.label" class="form-control _stealth" readonly>
          </td>
          <td>
            <input type="number" min="1" v-model="category.sort_order" class="form-control _stealth" readonly>
          </td>
          <td class="txt-danger cursor-pointer" style="width: 30px;" @click="deleteCategory(category.id)">
            <i class="fal fa-trash-alt"></i>
          </td>
          <td @click="editing = category" style="width: 30px;" class="cursor-pointer">
            <i class="fal fa-pencil"></i>
          </td>
        </tr>
        <tr v-else>
          <td>
            <select v-model="editing.faq_type_id" class="form-control">
              <option v-for="faq_type in faq_types" :value="faq_type.id"> {{ faq_type.label }}</option>
            </select>
          </td>
          <td class="w-full">
            <input type="text" v-model="editing.label" class="form-control">
          </td>
          <td class="align-center">
            <input type="number" min="1" v-model="editing.sort_order" class="form-control">
          </td>
          <td style="width: 30px;" class="cursor-pointer">
            <i class="fal fa-times" @click="editing = {}"></i>
          </td>
          <td @click="updateCategory()" style="width: 30px;" class="cursor-pointer">
            <i class="fal fa-save"></i>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'faq_types',
  ],
  data() {
    return {
      categories: [],
      editing: {},
      new_category: {
        faq_type_id: null,
      },
      loading: true,
      saving: false,
      deleting: false,
    };
  },
  mounted() {
    this.loadCategories();
  },
  methods: {
    loadCategories() {
      axios.post('/faqs/loadCategoriesForAdmin').then((response) => {
        this.categories = response.data;
        this.loading = false;
      });
    },
    updateCategory() {
      this.saving = true;

      const validationErrors = Validate({
        name: this.editing.label,
        faq_type: this.editing.faq_type_id,
        sort_order: this.editing.sort_order,
      }, {
        name: {
          presence: {
            allowEmpty: false,
          },
        },
        faq_type: {
          presence: {
            allowEmpty: false,
          },
        },
        sort_order: {
          presence: {
            allowEmpty: false,
          },
          numericality: {
            onlyInteger: true,
            greaterThanOrEqualTo: 1
          }
        },
      });

      if (validationErrors) {
        this.saving = false;
        Swal.fire({
          title: 'Unable to save category',
          icon: 'error',
          html: `<div class="mb-3">${Object.values(validationErrors).join('</div><div class="mb-3">')}</div>`,
        });
        return;
      }

      axios.post('/faqs/updateCategory', {
        category: this.editing,
      }).then(() => {
        this.editing = {};
        this.loadCategories();
        this.saving = false;
      });
    },
    createCategory() {
      this.saving = true;

      const validationErrors = Validate({
        name: this.new_category.label,
        faq_type: this.new_category.faq_type_id,
      }, {
        name: {
          presence: {
            allowEmpty: false,
          },
        },
        faq_type: {
          presence: {
            allowEmpty: false,
          },
        },
      });

      if (validationErrors) {
        this.saving = false;
        Swal.fire({
          title: 'Unable to save category',
          icon: 'error',
          html: `<div class="mb-3">${Object.values(validationErrors).join('</div><div class="mb-3">')}</div>`,
        });
        return;
      }

      axios.post('/faqs/createCategory', {
        category: this.new_category,
      }).then(() => {
        this.new_category = {};
        this.loadCategories();
        this.saving = false;
      });
    },
    deleteCategory(category_id) {
      this.deleting = true;

      Swal.fire({
        title: 'Are you sure you want to remove this category?',
        text: 'This action cannot be undone.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
      }).then((result) => {
        if (result.isConfirmed) {
          axios.post('/faqs/deleteCategory', {
            'category_id': category_id,
          }).then((response) => {
            this.loadCategories();
            this.deleting = false;
          });
        }
      });
    },
  },
};
</script>
